//cs-ecommerce/src/store/product/getters.js
export function customerListGetter (state) {
    return state.customerList;
}

export function customerWaitListGetter (state) {
    return state.customerList;
}
